// extracted by mini-css-extract-plugin
export default {"container":"container__MmEyZ","title":"title__MTJmM","description":"description__YjE1Z","dismiss":"dismiss__NzE2O"};